import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "alt"]


export default /*@__PURE__*/_defineComponent({
  __name: 'Card',
  props: {
    imageUrl: {},
    imageAlt: {},
    type: { default: 'horizontal' }
  },
  setup(__props: any) {

// Props with default values


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
            'flex items-center gap-5 px-4 py-3 bg-info-50 border border-info-100 rounded-lg',
            _ctx.type === 'vertical' && 'flex-col px-6 py-6',
            _ctx.type === 'horizontal' && 'flex-col sm:flex-row',
        ])
  }, [
    _createElementVNode("img", {
      class: _normalizeClass([
                'rounded border border-primary-200',
                _ctx.type === 'vertical' && 'w-full',
                _ctx.type === 'horizontal' && 'max-sm:w-full',
            ]),
      src: _ctx.imageUrl,
      alt: _ctx.imageAlt
    }, null, 10, _hoisted_1),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})